/**
 * Derive up to two initials from a display name.
 * - Single token (incl. CJK names): first grapheme.
 * - Multiple tokens: first grapheme of the first and last token.
 */
export function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const firstToken = parts[0];
  if (!firstToken) return '?';
  const first = [...firstToken][0] ?? '';
  if (parts.length === 1) return first.toUpperCase();
  const lastToken = parts[parts.length - 1] ?? '';
  const last = [...lastToken][0] ?? '';
  return (first + last).toUpperCase();
}
